import React, { useEffect, useState } from "react";
import left from "../../../assets/images/fastingPreferences/left.png";
import right from "../../../assets/images/fastingPreferences/right.png";
import pluse from "../../../assets/images/fastingPreferences/pluse.png";
import minus from "../../../assets/images/fastingPreferences/minus.png";
import axios from "axios";
import { FASTINGENDPOINT } from "../../../config/ApisCollection";
import { useLocation, useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// Import Swiper styles
import "swiper/css";
import secureLocalStorage from "react-secure-storage";

const FastingPlan = () => {
  const accessToken = secureLocalStorage.getItem("accessToken");

  let location = useLocation();
  let history = useNavigate();
  let locationstate = location.state;
  const [planFeatureIndex, setPlanFeatureIndex] = useState(0);

  const menuOption = [
    {
      name: "Sun",
      key: 1,
      value: 100,
    },
    {
      name: "Mon",
      key: 2,
      value: 10,
    },
    {
      name: "Tue",
      key: 3,
      value: 40,
    },
    {
      name: "Wed",
      key: 4,
      value: 67,
    },
    {
      name: "Thu",
      key: 5,
      value: 32,
    },
    {
      name: "Fri",
      key: 6,
      value: 40,
    },
    {
      name: "Sat",
      key: 7,
      value: 25,
    },
  ];
  //   const dispatch = useDispatch();

  const handleDashboardApi = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };
    await axios.get(FASTINGENDPOINT, request_body).then((response) => {
      // console.log(response.data);
    });
  };

  const handleChoose = () => {
    history("/fasting/setup/setup", { state: locationstate[planFeatureIndex] });
  };

  useEffect(() => {
    // handleDashboardApi();
  }, []);

  // console.log(planFeatureIndex);

  return locationstate ? (
    <div className="container mx-auto sm:w-3/4">
      <div className="w-full h-full">
        <div className="w-full flex mb-2 mt-10"></div>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          slidesPerView={1}
          spaceBetween={10}
          navigation
          pagination={{ clickable: true }}
          onSwiper={(swiper) => {}}
          onSlideChange={(swiper) => {
            setPlanFeatureIndex(swiper.activeIndex);
          }}
        >
          {locationstate.map((frow, index) => (
            <SwiperSlide key={index}>
              <div
                className={` rounded-2xl px-3 py-4 text-center  border border-[${frow.borderColorCode}] bg-[${frow.bgColorCode}] max-w-[550px] w-full`}
                style={{
                  backgroundColor: index == 0 ? "#EEFFFB" : "",
                  borderColor: index == 0 ? "#23F1C0" : "",
                }}
              >
                <span className="text-xs font-semibold">{frow.plan}</span>
                <div className="flex gap-3 items-center justify-center">
                  <div className="text-left relative">
                    <span className="text-[11px] text-[#FF9950] font-medium mb-5 block">
                      Fasting
                    </span>
                    <img
                      src={left}
                      alt="ttet"
                      className="absolute -right-3 top-2"
                    />
                  </div>
                  <span className="text-4xl font-semibold">
                    {frow.fastingWindow}:{frow.eatingWindow}
                  </span>
                  <div className="text-left relative">
                    <img
                      src={right}
                      alt="ttet"
                      className="absolute -left-3 -top-0"
                    />
                    <span className="text-[11px] text-[#FF9950] font-medium mt-5 block">
                      Eating
                    </span>
                  </div>
                </div>
                <div className="flex bg-white justify-center py-2.5 px-3 items-center gap-3 mt-3 rounded-2xl w-9/12 mx-auto">
                  <p className="text-base font-semibold">
                    {frow.startTime12hr}
                  </p>
                  <span className="text-[11px] font-medium">to</span>
                  <p className="text-base font-semibold">{frow.endTime12hr}</p>
                </div>
                <p className="text-[11px] font-normal mt-3">{frow.title}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="flex justify-center flex-col gap-10 mt-12 w-11/12 mx-auto pb-10">
          <div className=" mt-5 bg-[#fff] rounded-3xl px-3 py-4 text-center">
            <div className="w-full">
              <h2 className="pb-7 text-2xl">
                <span className="text-[#FF9950]">Features</span> of the plan
              </h2>
              <div className="grid lg:grid-cols-4 gap-5 text-start">
                {locationstate[planFeatureIndex].features.map(
                  (feature_list, index) => (
                    <div key={index}>
                      <h3 className="font-medium mb-2">{feature_list.title}</h3>
                      <p>{feature_list.subtitle}</p>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <button
            className="bg-[#FF9950] absolutes right-16 bottom-10 text-white text-sm mx-auto w-7/12 py-4 mt-6 rounded-2xl"
            onClick={handleChoose}
          >
            Choose
          </button>
        </div>
      </div>
    </div>
  ) : (
    <>Data not found...</>
  );
};

export default React.memo(FastingPlan);
